module.exports = __webpack_public_path__ + "img/智能化设备管理平台2.016bb1ad.jpg";